const AVATAR_COLORS = [
  'bg-[#0c1b4d]', 'bg-blue-600', 'bg-emerald-600', 'bg-purple-600',
  'bg-rose-600', 'bg-amber-600', 'bg-teal-600', 'bg-indigo-600',
];

function avatarColor(id) {
  return AVATAR_COLORS[id % AVATAR_COLORS.length];
}

function initials(name = '') {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
}

export function Avatar({ id, name, size = 36 }) {
  return (
    <div
      className={`flex-shrink-0 rounded-full flex items-center justify-center text-white font-semibold ${avatarColor(id)}`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
    >
      {initials(name)}
    </div>
  );
}
